import React from 'react';
import { Form, FormGroup, ValidationMessage } from '~/components/Form';
import { ServicesContext } from '~/services';
import { Card } from '~/components/Card';
import { Spinner } from 'react-bootstrap';

export function Forgot() {
    const servicesContext = React.useContext(ServicesContext);
    const [submitted, setSubmitted] = React.useState(false);
    const [email, setEmail] = React.useState('');
    const [validation, setValidation] = React.useState(false);
    const [responseMessage, setResponseMessage] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    async function handleSubmit() {
        try {
            setLoading(true);
            const result = await servicesContext.user.requestReset(email);
            setSubmitted(true);
            setResponseMessage(result);
            setLoading(false);
        } catch (error) {
            setValidation(true);
            setResponseMessage(error.message);
            setLoading(false);
        }
    }

    return (
        <Card title="Reset Your Password">
            {!submitted ? (
                <Form onSubmit={handleSubmit} values={{ email }}>
                    <FormGroup htmlFor="email" className="mb-3 row">
                        <label htmlFor="email" className="col-3 col-form-label">
                            Email
                        </label>
                        <div className="col-9">
                            <input
                                type="email"
                                required
                                className="form-control"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <ValidationMessage type="required" className="offset-3 col-9">
                            Email is required.
                        </ValidationMessage>
                        <ValidationMessage type="email" className="offset-3 col-9">
                            Please enter a valid email.
                        </ValidationMessage>
                        <ValidationMessage
                            type="external"
                            rule={validation}
                            className="offset-sm-5 offset-lg-4 col-12 col-sm-7 col-lg-8"
                        >
                            {responseMessage}
                        </ValidationMessage>
                    </FormGroup>
                    <div className="row">
                        <div className="col text-end">
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading && (
                                    <Spinner
                                        animation="border"
                                        variant="light"
                                        size="sm"
                                        role="status"
                                        className="me-1"
                                    />
                                )}
                                Send Instructions
                            </button>
                        </div>
                    </div>
                </Form>
            ) : (
                <div>
                    <p>{responseMessage}</p>
                    <p>
                        The link you receive in your email must be opened in this browser. If this
                        is not your default browser, copy and paste the link you received into this
                        browser in order to reset your password.
                    </p>
                </div>
            )}
        </Card>
    );
}
